<template>
    <div class="d-flex" v-if="params.data.transaction_id">
        <b-button v-if="rowData.length" @click="$bvModal.show(logModalId)" variant="default">Log</b-button>
        <modal :id="logModalId" size="lg" title="Verification Logs" :ok-only="true">
            <grid
                :isAutoWidth="true"
                :isSearch="false"
                :rowData="rowData"
                :isAutoHeight="true"
                :columnDefs="columnDefs"
                :autoWidthExclude="['message']"
            ></grid>
        </modal>
    </div>
</template>

<script>
    import Grid from '../../generic/grid/grid.vue';
    import modal from '../../generic/modal/modal.vue';
    export default {
        components: {
            modal,
            Grid,
        },
        computed: {
            logModalId() {
                return 'modal-verify-log-id' + this.params?.data?.id;
            },
            rowData() {
                return this.params.data?.logs || [];
            },
            columnDefs() {
                return [
                    {
                        field: 'created',
                        headerName: 'Timestamp',
                        type: 'dateTimeColumn',
                    },
                    {
                        field: 'message',
                    },
                ];
            },
        },
    };
</script>

<style></style>
